import { Controller } from "@hotwired/stimulus"
import { Issue } from "../channels/issue_channel"

// Connects to data-controller="issue-form"
export default class extends Controller {
  static targets = [
    "form",
    "block",
    "tabContent",        // root div fires tabContentTargetConnected after Tab-Update
    "modifiedTabsField", // find fields, changes in tabs, and add them to this field
    "menu",
    "toggleMenu",
    "saveButton",
    "buttonPrev",
    "buttonNext",
    "displayMode",
    "currentTab",
    "employers",
    "damages",
    "socials",
    "issueId",
    "seed",
    "employerId",

    "saleryType",
    "saleryTypeField",

    // this field indicates switch to hourly salery
    // and initialize errors if there
    "saleryRandom"
  ];

  connect () {
    this.modifiedTabs = new Set()
  }

  disconnect () {
    this?.issue?.unsubscribe()
  }

  formTargetConnected () {
    this.orig_form_data = new FormData(this.formTarget)
    if (!this.issue) {
      this.issue = new Issue(this.issueIdTarget.value)
    }

    if (this.displayModeTarget?.value && this.currentTabTarget?.value) {
      this.change_visible_block_to(this.currentTabTarget.value)
    }

    this.find_and_display_errors()
  }

  tabContentTargetConnected () {
    this.find_and_display_errors()
    if (this.hasFormTarget) {
      // empty the result of last changed fields and therfor tabs
      if (this.hasModifiedTabsFieldTarget) this.modifiedTabsFieldTarget.value = ''
      this.orig_form_data = new FormData(this.formTarget)
    }
  }

  focus (evt) {}

  // mark tab in which field ist located that has changed
  change (evt) {
    const block = evt.target.closest('[data-issue-form-target~="block"]')
    if (!block) return

    const tabClass = [...block.classList].find(c => c.startsWith('issue-') && c !== 'issue-block')
    if (tabClass) this.modifiedTabs.add(tabClass.replace('issue-', ''))
  }

  toggle_hidden_fields() {
    document.querySelectorAll(`#${this.element.id} span.hidden-field`)
            .forEach(f => f.classList.toggle('hidden'))
  }

  set_action (evt) {
    this.form_action = evt.params.action
  }

  find_differences() {
    const differences = []

    for (const [ k, v ] of new FormData(this.formTarget).entries()) {
      if (this.orig_form_data.get(k) !== v) {
        if ( k !== 'issue[telefon_privat_input]' &&
             k !== 'issue[svn]' && v !== 'nnn.nnnn.nnnn.nn' &&
             k !== 'modified_tabs'
        ) {
          differences.push({ [ k ]: v })
        }
      }
    }
    return differences
  }

  formSubmit() {
    this.saveButtonTarget.click()
  }

  send (evt) {
    const current_form_data = new FormData(this.formTarget)
    const differences = this.find_differences(current_form_data.entries())

    try {
      if ( this.form_action == 'return' ||
           this.form_action == 'forward' ||
           ( differences && differences.length > 0 )
      ) {
        Turbo.navigator.delegate.adapter.progressBar.setValue(0)
        Turbo.navigator.delegate.adapter.progressBar.show()

        differences.push({ id: this.issueIdTarget.value })
        differences.push({ random_id: current_form_data.get("random_id") })
        differences.push({ login_id: current_form_data.get("login_id") })
        differences.push({ display_mode: current_form_data.get("display_mode") })
        differences.push({ current_block: current_form_data.get("current_block") })

        if (this.hasModifiedTabsFieldTarget && this.modifiedTabs.size > 0) {
          this.modifiedTabsFieldTarget.value = [...this.modifiedTabs].join(',')
        }

        this.issue.send_changed_data({ data: differences })
        this.modifiedTabs.clear()
        this.orig_form_data = current_form_data
      } else {
        evt.preventDefault()
      }
    } catch (error) {
      console.log(error)
    }
  }

  prev (evt) {
    let block = this.current_block()
    let idx = this.index_block(block)
    let len = this.count_blocks()
    let new_pos = 0

    document.getElementById('interact-warning-content').classList.add('hidden')

    evt.preventDefault()

    if (idx - 1 >= 0) {
      new_pos = idx - 1
    } else {
      new_pos = len - 1
    }

    this.currentTabTarget.value = new_pos
    this.change_visible_block_to(new_pos)
  }

  next (evt) {
    const block = this.current_block()
    const idx = this.index_block(block)
    const len = this.count_blocks()
    let new_pos = 0

    document.getElementById('interact-warning-content').classList.add('hidden')

    evt.preventDefault()

    if (idx + 1 < len) {
      new_pos = idx + 1
    } else {
      new_pos = 0
    }

    this.currentTabTarget.value = new_pos
    this.change_visible_block_to(new_pos)
  }

  toggleDisplay (evt) {
    evt.preventDefault()

    if (
      this.displayModeTarget?.value &&
      this.displayModeTarget.value == "block"
    ) {
      this.displayModeTarget.value = "all"
      this.show_all_blocks()
      this.menuTarget.classList.add("hidden")
      this.toggleMenuTarget.innerHTML =
        "<i class='fa fa-address-card'></i> Block anzeigen"
    } else {
      this.displayModeTarget.value = "block"
      this.hide_all_blocks()
      this.change_visible_block_to(0)
      this.menuTarget.classList.remove("hidden")
      this.toggleMenuTarget.innerHTML =
        "<i class='fa fa-list-ul'></i> Alle Daten"
    }
  }

  //
  // change a tab when clicking on a link in nav - menu
  //
  switch_to (evt) {
    evt.preventDefault()

    const name = evt.params.target
    const block = this.find_block(name)
    const idx = this.index_block(block)

    this.currentTabTarget.value = idx
    this.change_visible_block_to(idx)

    this.menuTarget.querySelectorAll("li a").forEach(e => {
      e.classList.remove('font-semibold')
    })
    evt.target.classList.add('font-semibold')
  }

  hide_all_blocks () {
    this.blockTargets.forEach((b) => b.classList.add("hidden"))
    this.buttonPrevTarget.classList.remove("hidden")
    this.buttonNextTarget.classList.remove("hidden")
  }

  show_all_blocks () {
    this.blockTargets.forEach((b) => b.classList.remove("hidden"))
    this.buttonPrevTarget.classList.add("hidden")
    this.buttonNextTarget.classList.add("hidden")
  }

  change_visible_block_to (idx) {
    this.blockTargets.forEach((b) => b.classList.add("hidden"))
    this.blockTargets[ idx ].classList.remove("hidden")
  }

  find_block (name) {
    return this.blockTargets.find((b) => {
      return b.classList.contains(name)
    })
  }

  current_block () {
    return this.blockTargets.find((b) => !b.classList.contains("hidden"))
  }

  index_block (block) {
    return this.blockTargets.indexOf(block)
  }

  count_blocks () {
    return this.blockTargets.length
  }

  //
  // we search through all blocks an try to find errors
  // and warnings
  //
  find_and_display_errors () {
    Turbo.navigator.delegate.adapter.progressBar.setValue(1)
    Turbo.navigator.delegate.adapter.progressBar.hide()

    // find all links and take the id's to find blocks
    this.menuTarget.querySelectorAll("li a").forEach((b) => {
      const cnt = this.formTarget.querySelectorAll(
        `.${ b.dataset.issueFormTargetParam } input.error,
         .${ b.dataset.issueFormTargetParam } select.error,
         .${ b.dataset.issueFormTargetParam } textarea.error,
         .${ b.dataset.issueFormTargetParam } div span.warning`,
      )?.length
      if (cnt > 0) {
        this.formTarget.querySelector(
          `.${ b.dataset.issueFormTargetParam }-error-cnt`,
        ).innerHTML = cnt
        this.formTarget
          .querySelector(`.${ b.dataset.issueFormTargetParam }-error-cnt`)
          ?.classList?.remove("hidden")
      } else {
        this.formTarget
          .querySelector(`.${ b.dataset.issueFormTargetParam }-error-cnt`)
          ?.classList?.add("hidden")
      }
    })
  }

  saleryRandomTargetConnected () {
    this.find_and_display_errors()
  }

  changeSalery (evt) {
    evt.target
       .closest("div")
       .querySelectorAll("a")
       .forEach((e) => {
         e.classList.remove("bg-sky-600/80", "text-white")
       })
    evt.target.classList.add("bg-sky-600/80", "text-white")
    this.saleryTypeFieldTarget.value = evt.params.saleryTypeId
  }

  showBlock (evt) {
    evt.preventDefault()

    let cnt = 0
    this[ `${ evt.params["block"] }Targets` ].forEach((e) => {
      if (e.classList.contains("hidden")) {
        cnt++
        if (cnt <= 1) e.classList.remove("hidden")
      }
    })
  }
}
